"use strict";

define('rs/form/formobjects/group/group.formobject',['rs/form/formobjects/base.formobject', 'rs/form/boolean.dynamicproperty'], function (BaseFormObject, BooleanDynamicProperty) {
  var GroupFormObject = BaseFormObject.extend({
    propertiesDefinitions: ['name', 'required', 'label', 'text', 'description', 'helpText'],
    linksDefinitions: [],
    setupFormObject: function setupFormObject() {
      this._super.apply(this, arguments);
      this.setupDynamicProperties();
      if (this.isDesignerMode() && !this.getCompoundType()) {
        if (this.isRadioGroup()) {
          this.setCompoundType('radio');
        } else if (this.isCheckboxGroup()) {
          this.setCompoundType('checkbox');
        }
      }
    },
    setupDynamicProperties: function setupDynamicProperties() {
      var dp = new BooleanDynamicProperty(this.getChildren(), this, "absoluteValid");
      this.setValid(dp);
      dp.start();
    },
    getGroupId: function getGroupId() {
      this._uniqueId = this._uniqueId || GroupFormObject.getUniqueId();
      return this.getId() + "-" + this._uniqueId;
    },
    isCommentable: function isCommentable() {
      var children = this.getChildren(),
        child = null,
        len = children ? children.length : 0;
      type = '', i = 0;
      for (i = 0; i < len; ++i) {
        child = children[i];
        if (child.type == 'label') {
          continue;
        }
        type = type || child.type;
        if (child.type !== type || type != 'radio' && type != 'checkbox') {
          return false;
        }
      }
      return len > 1 ? true : false;
    }
  }, {
    getTypeString: function getTypeString() {
      return 'Group';
    },
    uniqueIdCounter: 0,
    getUniqueId: function getUniqueId() {
      return this.uniqueIdCounter++;
    }
  });
  return GroupFormObject;
});

